import {
  getCurrentUser,
  getConnectionCreated,
  setConnectionCreated
} from "./auth0";
import AppModel from "@/models/application";
import store from "../store";
import api from "@/api";

export var dataTourActive = false;

export function appcuesCallbacks() {
  window.Appcues.on("flow_started", () => {
    dataTourActive = true;
  });
  window.Appcues.on("flow_completed", () => {
    dataTourActive = false;
  });
  window.Appcues.on("flow_skipped", () => {
    dataTourActive = false;
  });
  window.Appcues.on("step_aborted", () => {
    dataTourActive = false;
  });
  window.Appcues.on("step_child_deactivated", () => {
    dataTourActive = false;
  });
  window.Appcues.on("step_child_activated", () => {
    dataTourActive = true;
  });
  window.Appcues.on("checklist_dismissed", () => {
    window.Appcues.clearShow(); // Somehow navigation brings the checklist back, this stops that from happening
  });
  window.Appcues.on("checklist_skipped", () => {
    window.Appcues.clearShow();
  });
  if (api.props.config.environment !== "prod") {
    // for debug purposes
    window.Appcues.on("all", event => {
      console.log(event);
      console.log("data tour is " + (dataTourActive ? "" : "in") + "active");
    });
  }
}

export function appcuesIdentify(userId, identifiers) {
  try {
    window.Appcues.identify(userId, identifiers);
  } catch (ex) {
    console.log("Appcues.identify() failed", ex);
  }
}

export function callPage() {
  window.Appcues.page();
}

export function updateOrganization(organization) {
  appcuesIdentify(localStorage.userId, {
    // Unique identifier for current user
    FirstName: organization.primaryContact.firstName,
    LastName: organization.primaryContact.lastName, // current user's name
    Email: organization.primaryContact.emailAddress, // Current user's email
    Phone: organization.primaryContact.phoneNumber,
    CreateDate: organization.createdOn, // Unix timestamp of user signup date
    Company: organization.name // Current user’s company
  });
}

export function updateSubscription(subscription) {
  appcuesIdentify(localStorage.userId, {
    // Unique identifier for current user
    PlanName: subscription.platformPlan.name, // Current user’s plan tier
    PlanType: subscription.platformPlan.planType,
    LSC_SubStatus: subscription.platformPlan.status, // Current user’s plan type
    LSC_SupAddonName: subscription.supportPlan.name,
    LSC_TrialEndDate: subscription.trialEndOn,
    LSC_TrialStartDate: subscription.trialStartOn,
    LSC_SubStartDate: subscription.activatedOn,
    LSC_SubEndDate: subscription.currentTermEnd
  });
}

export function checkForConnection() {
  if (!getConnectionCreated()) {
    var user = getCurrentUser();
    if (user != undefined && !user.lscConnectionCreated) {
      if (store.get("applications/entities").length === 0) {
        store.dispatch("applications/loadEntities").then(() => {
          checkForConnectionActual();
        });
      } else {
        if (user.lscConnectionCreated) {
          setConnectionCreated("true");
        }
        checkForConnectionActual();
      }
    }
  }
}

function checkForConnectionActual() {
  var user = getCurrentUser();
  var appIds = store.get("applications/entities");
  var queryArray = [{ k: "tag", v: "connection_exists" }];
  for (var i = 0; i < appIds.length; i++) {
    queryArray.push({
      k: "applicationId",
      v: appIds[i].applicationId
    });
  }
  //do call to check big query
  api
    .getEntity(api.props.endPoints.dashboardQuery, null, queryArray)
    .then(result => {
      if (result.length == 1 && result[0].hasConnection) {
        user.lscConnectionCreated = result[0].hasConnection;
        appcuesIdentify(user.id, {
          // Unique identifier for current user
          LSC_ConnectionCreated: user.lscConnectionCreated
        });
        store.dispatch("user/updateEntity", user);
      }
    });
}

export function generateAppToken(id = null, secret = null, tokenInput = null) {
  var applicationId = id;
  var sharedSecret = secret;
  return new Promise(resolve => {
    store
      .dispatch("applications/loadEntities") // Avoid race conditions
      .then(() => {
        if (applicationId === null || sharedSecret === null) {
          var apps = store.get("applications/entities");
          if (typeof apps == "undefined" || apps == null || apps.length == 0) {
            appcuesIdentify(localStorage.userId, {
              LSC_FirstAppID: null,
              LSC_Token: null,
              LSC_Gateway_URL: null
            });
            return;
          }
          applicationId = apps[apps.length - 1].applicationId;
          sharedSecret = apps[apps.length - 1].sharedSecret;
        }
        var clientId = store.getters.guidGenerator().replace("-", "");
        var channel = Math.floor(100000 + Math.random() * 900000).toString();
        var jwt = require("jsonwebtoken");
        var payload = {
          type: "register",
          applicationId: applicationId,
          clientId: clientId,
          channels: [{ id: channel }]
        };
        var token = jwt.sign(payload, sharedSecret, { expiresIn: "1d" });
        appcuesIdentify(localStorage.userId, {
          LSC_FirstAppID: applicationId,
          LSC_Token: token,
          LSC_Gateway_URL: api.props.config.codepenGatewayUrl
        });
        if (tokenInput !== null) {
          tokenInput.value = token;
        }
        resolve(token);
      });
  });
}

export function autoCreateApp() {
  var newApp = new AppModel();
  newApp.tag = "My App";
  newApp.applicationId = store.getters.guidGenerator();
  newApp.sharedSecret = store.getters.sharedSecretGenerator();
  store.dispatch("applications/createEntity", newApp).then(() => {
    var user = getCurrentUser();
    if (user != undefined && !user.lscAppCreated) {
      user.lscAppCreated = true;
      appcuesIdentify(user.id, {
        // Unique identifier for current user
        LSC_AppCreated: user.lscAppCreated
      });
      store.dispatch("user/updateEntity", user);
    }
    // generate and expose a token to Appcues
    generateAppToken(newApp.applicationId, newApp.sharedSecret);
  });
}
